import { Alert, Share as ReactNativeShare, ShareAction, ShareContent, ShareOptions } from 'react-native';
import { build } from '../../src';

const showAlert = () =>
  Alert.alert(
    'Share using the Fitillion app on your mobile device',
    '',
    [
      {
        text: 'Continue',
        style: 'cancel',
      },
    ],
    {
      cancelable: true,
    },
  );

export class Share {
  public static readonly ShareAction = ReactNativeShare.sharedAction;
  public static readonly dismissedAction = ReactNativeShare.dismissedAction;

  public static share(content: ShareContent, options?: ShareOptions): Promise<ShareAction> {
    if (build.variant.isElite) {
      showAlert();
      return new Promise<ShareAction>(((resolve) => resolve({ action: 'dismissedAction' })));
    }
    return ReactNativeShare.share(content, options);
  }
}
